import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

const defaultOptions = {
  inputRows: 1, // Values > 1 will render textarea's (with rows property equals to this value)
  defaultRequired: true, //Is the default langauge required
  maxlength: undefined,
  placeholders: {}, //Placeholders per language {nl:'',fr:'',en:''}
};

angular.module('cloudX').directive('cxTranslateListItem', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: `<div class="form-horizontal" role="form" ng-form="form">
        <div class="form-group" ng-repeat="tr in translations" ng-init="inputName=('value_'+tr.language);">
          <label class="control-label" ng-class="labelClass||'col-md-3'"><span>{{labelPrefix}}</span>&nbsp;{{ tr.language }}</label>
          <div ng-class="inputClass||'col-md-6'">
            <input
              type="text"
              name="{{inputName}}"
              class="form-control"
              ng-model="tr.value"
              ng-required="tr.isTenantLanguage && defaultRequired"
              ng-disabled="disabled||saving!==null"
              ng-change="translationChanged(tr)"
              ng-class="{'markedError':(showValidation || form[inputName].$dirty) && form[inputName].$invalid}"
              maxlength="{{maxlength}}"
              placeholder="{{tr.placeholder}}"
              autocomplete="off"
              ng-if="::!isTextArea"
            />
            <textarea
              type="text"
              name="{{inputName}}"
              class="form-control vertical-resize"
              ng-model="tr.value"
              ng-required="tr.isTenantLanguage && defaultRequired"
              ng-disabled="disabled||saving!==null"
              ng-change="translationChanged(tr)"
              ng-class="{'markedError':(showValidation || form[inputName].$dirty) && form[inputName].$invalid}"
              maxlength="{{maxlength}}"
              placeholder="{{tr.placeholder}}"
              autocomplete="off"
              rows="{{inputRows}}"
              ng-if="::isTextArea"
            />
          </div>
        </div>
      </div>`,
      scope: {
        list: '@',
        listid: '=?',
        fallback: '=?',
        accessor: '=?',
        defaultChanged: '&',
        labelPrefix: '@?',
        labelClass: '@?',
        inputClass: '@?',
        options: '=?',
        disabled: '=?',
        maxlength: '@?', //Can also be set in options
      },
      controller: [
        '$scope',
        '$q',
        '$http',
        '$translate',
        'flySvc',
        'appUrls',
        'dataCache',
        function($scope, $q, $http, $translate, flySvc, appUrls, dataCache) {
          $scope.saving = null;
          $scope.showValidation = false;
          $scope.translations = [];
          const options = { ...defaultOptions, ...($scope.options || {}) };
          $scope.inputRows = options.inputRows || 1;
          $scope.isTextArea = $scope.inputRows > 1;
          $scope.defaultRequired = options.defaultRequired;
          $scope.maxlength = options.maxlength || $scope.maxlength;
          $scope.placeholders = options.placeholders;

          $scope.isValid = function(showValidation) {
            $scope.showValidation = showValidation;
            return $scope.form.$valid;
          };
          var handleError = function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return error;
          };
          $scope.save = function(listid) {
            if ($scope.saving) return $scope.saving;
            if (!listid) listid = $scope.listid;
            if (!listid) return $q.reject('No id provided');
            if (!$scope.isValid()) return $q.reject('Translations not valid');
            var changes = $scope.translations
              .filter(el => el.orgValue !== el.value)
              .map(({ orgValue, ...el }) => ({ ...el, key: `${$scope.list}_${listid}` }));
            if (!changes || !changes.length) {
              return $q.when([]);
            }
            $scope.saving = $http
              .put(appUrls.api + '/api/translation/lists/0', changes)
              .then(function() {
                // Reload all loaded languages
                $translate.refresh();
                return changes;
              }, handleError)
              .finally(() => {
                $scope.saving = null;
              });
            return $scope.saving;
          };
          $scope.translationChanged = function(translation) {
            if (translation && translation.isTenantLanguage && $scope.defaultChanged) {
              $scope.defaultChanged({ value: translation.value });
            }
          };
          $scope.$watch('accessor', function() {
            if ($scope.accessor) {
              $scope.accessor.save = $scope.save;
              $scope.accessor.isValid = $scope.isValid;
            }
          });

          if ($scope.listid) {
            $http
              .get(appUrls.api + '/api/translation/list/' + $scope.list + '/' + $scope.listid)
              .then(function({ data = [] }) {
                $scope.translations = data.map(el => ({
                  ...el,
                  value: el.isTenantLanguage && !el.value ? $scope.fallback : el.value,
                  orgValue: el.value,
                  placeholder:
                    ($scope.placeholders && $scope.placeholders[el.language]) ||
                    `${$scope.labelPrefix || ''} ${el.language}`.trim(),
                }));
              }, handleError);
          } else {
            dataCache.ready().then(function() {
              $scope.translations = dataCache
                .getArray('language')
                .sort(dynamicSortMultiple('-isDefault', 'code'))
                .map(l => ({
                  key: null,
                  language: l.code,
                  value: l.isDefault ? $scope.fallback || '' : '',
                  orgValue: '',
                  isTenantLanguage: l.isDefault,
                  placeholder:
                    ($scope.placeholders && $scope.placeholders[l.code]) ||
                    `${$scope.labelPrefix || ''} ${l.code}`.trim(),
                }));
            });
          }
        },
      ],
    };
  },
]);
